import Vue from "vue";
import config from "config";
import API from "./http";

export default {
  async signup() {
    try {
      const res = await API.post(`${config.CORP_API_URL}/signup`);

      const { headers } = res;

      if (headers["x-auth-token"]) {
        // Token
        Vue.auth.token("access_token", headers["x-auth-token"]);
      }

      return res.data;
    } catch (err) {
      console.error("Error getting balance report", err);
      throw err;
    }
  },
};
